import Loader from "pages/Loader"
import PermittedComponent from "PermittedComponent"
import React, { useEffect, useMemo, useState } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { MdAdd, MdDelete, MdDownload, MdEdit, MdUpload } from "react-icons/md"
import { useNavigate } from "react-router-dom"
import {
  FaChevronLeft,
  FaChevronRight,
  FaRupeeSign,
  FaUser,
} from "react-icons/fa"
import { usePermissionData } from "AppContext"
import ConfigUrl, { axiosbaseurl } from "../../config"
import moment from "moment"
import { IoMdWarning } from "react-icons/io"
import { SiTicktick } from "react-icons/si"
import { Modal, notification } from "antd"
import Swal from "sweetalert2"
import SampleFile from "../../assets/images/Payments.xlsx"
import { RiArrowUpDownFill } from "react-icons/ri"

const Payout = () => {
  const { checkAccess } = usePermissionData()
  const [Data, setData] = useState([])
  const [Loading, setLoading] = useState(false)
  const [Payments, setPayments] = useState([])
  const [Customers, setCustomers] = useState([])
  const [SelectedCustomer, setSelectedCustomer] = useState(0)

  const [AddModal, setModal] = useState(false)
  const [PaymentsFile, setPaymentsFile] = useState()

  const handleSampleDownload = () => {
    const sampleFileUrl = SampleFile // File stored in public/files
    const link = document.createElement("a")
    link.href = sampleFileUrl
    link.download = "Sample_Payments.xlsx" // Sets the download filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  const handleUpload = async () => {
    setModal(false)

    try {
      setLoading(true)

      const formData = new FormData()
      formData.append("payments", PaymentsFile)

      const response = await axiosbaseurl.post(
        `payments/upload/payments`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )

      if (response?.data?.success) {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex align-items-center">
              <div className="pr-20">
                <SiTicktick className="text-success fs-4 me-2" />
              </div>
              <div className="succes-message">{response?.data?.message}</div>
            </div>
          ),
          placement: "topRight",
        })
        getData()
      } else {
        setLoading(false)
        notification.open({
          message: (
            <div className="d-flex">
              <div className="pr-10">
                <IoMdWarning className="text-danger" size={22} />
              </div>
              <div>Opps! Something went wrong.</div>
            </div>
          ),
        })
      }
    } catch (e) {
      setLoading(false)
      notification.open({
        message: (
          <div className="d-flex">
            <div className="pr-10">
              <IoMdWarning className="text-danger" size={22} />
            </div>
            <div>Opps! Something went wrong.</div>
          </div>
        ),
        description: e?.response?.data?.message,
      })
    }
  }

  useEffect(() => {
    console.log(SelectedCustomer)
    if (SelectedCustomer == 0) {
      setData(Payments)
    } else {
      setData(Payments?.filter(item => item?.customerId == SelectedCustomer))
    }
  }, [SelectedCustomer])

  const Navigate = useNavigate()

  useEffect(() => {
    getData()
    getCustomerData()
  }, [])

  async function getData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`payments`)
      if (response?.data?.success) {
        setData(response?.data?.data?.reverse())
        setPayments(response?.data?.data)
        setSelectedCustomer(0)
      }
    } catch (e) {
      console.log("Error", e)
    } finally {
      setLoading(false)
    }
  }

  async function getCustomerData() {
    setLoading(true)
    try {
      const response = await axiosbaseurl.get(`customer-management`)
      if (response?.data?.success) {
        setCustomers(response?.data?.data)
      }
    } catch (e) {
      console.log("Error", e.response.data.message)
    } finally {
      setLoading(false)
    }
  }

  const filterByName = e => {
    const filteredData = Payments?.filter(
      session =>
        session?.customer?.customerName
          .toLowerCase()
          .includes(e.target.value.toLowerCase()) ||
        session?.VoucherNo?.toLowerCase().includes(
          e.target.value.toLowerCase()
        ) ||
        session?.Type?.toLowerCase().includes(e.target.value.toLowerCase()) ||
        session?.Debit?.toLowerCase().includes(e.target.value.toLowerCase()) ||
        session?.Credit?.toLowerCase().includes(e.target.value.toLowerCase())
    )

    setData(filteredData)
  }

  const handleDelete = ID => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Payment",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const response = await axiosbaseurl.delete(`/payments/${ID}`) // Use correct API endpoint

          if (response?.data?.success) {
            notification.open({
              message: (
                <div className="d-flex align-items-center">
                  <div className="pr-20">
                    <SiTicktick className="text-success fs-4 me-2" />
                  </div>
                  <div className="succes-message">
                    Payment Deleted Successfully.
                  </div>
                </div>
              ),
              placement: "topRight",
            })

            // Refresh user list after delete
            getData()
          }
        } catch (error) {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-10">
                  <IoMdWarning className="text-danger" size={22} />
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
            description: error?.response?.data?.message,
          })
        }
      }
    })
  }

  const [page, setPage] = useState(1)

  useEffect(() => window.scrollTo(0, 0), [])

  const [items_perpage, setItemsPerPage] = useState(10)

  const total_pages = Math.ceil(Data?.length / items_perpage)

  const changePage = pagecount => {
    if (pagecount > 0 && pagecount <= total_pages) {
      setPage(pagecount)
      window.scrollTo(0, 0)
    }
  }

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  })

  const sortedData = useMemo(() => {
    if (!sortConfig.key) return Data

    const sortableItems = [...Data]
    sortableItems.sort((a, b) => {
      let aValue, bValue

      switch (sortConfig.key) {
        case "VoucherNo":
          aValue = a.VoucherNo || ""
          bValue = b.VoucherNo || ""
          break
        case "customerName":
          aValue = (a.customer?.customerName || "").toLowerCase()
          bValue = (b.customer?.customerName || "").toLowerCase()
          break
        case "Date":
          const parseDate = dateStr => {
            if (!dateStr) return new Date(0)

            // Detect format automatically
            if (dateStr.includes("/")) {
              // DD/MM/YYYY
              const [day, month, year] = dateStr.split("/").map(Number)
              return new Date(year, month - 1, day)
            } else if (dateStr.includes("-")) {
              // YYYY-MM-DD
              const [year, month, day] = dateStr.split("-").map(Number)
              return new Date(year, month - 1, day)
            }

            return new Date(0) // fallback
          }

          aValue = parseDate(a.Date)
          bValue = parseDate(b.Date)
          break

        case "Type":
          aValue = a.Type || ""
          bValue = b.Type || ""
          break
        case "Amount":
          aValue =
            a.Type === "PAYMENT"
              ? parseFloat(String(a.Debit).replace(/[^0-9.-]+/g, "")) || 0
              : parseFloat(String(a.Credit).replace(/[^0-9.-]+/g, "")) || 0
          bValue =
            b.Type === "PAYMENT"
              ? parseFloat(String(b.Debit).replace(/[^0-9.-]+/g, "")) || 0
              : parseFloat(String(b.Credit).replace(/[^0-9.-]+/g, "")) || 0
          break
        default:
          aValue = a[sortConfig.key]
          bValue = b[sortConfig.key]
      }

      if (aValue < bValue) return sortConfig.direction === "ascending" ? -1 : 1
      if (aValue > bValue) return sortConfig.direction === "ascending" ? 1 : -1
      return 0
    })

    return sortableItems
  }, [Data, sortConfig])

  const final_data = sortedData.slice(
    (page - 1) * items_perpage,
    page * items_perpage
  )

  const requestSort = key => {
    let direction = "ascending"
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending"
    }
    setSortConfig({ key, direction })
  }

  const getSortArrow = key => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "ascending" ? "▲" : "▼"
    }
    return <RiArrowUpDownFill size={18} />
  }

  const totalPayout = sortedData?.reduce((acc, item) => {
    if (item?.Type.toLowerCase() === "payment") {
      acc += Number(item?.Debit)
    }
    return acc
  }, 0)

  return (
    <React.Fragment>
      {Loading && <Loader />}
      <PermittedComponent isAccess={checkAccess(10, 1)}>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title={""} breadcrumbItem={"Payments"} />

            <div className="card p-2 py-3">
              <div className="d-flex flex-column flex-xl-row justify-content-between">
                <div className="d-flex gap-4">
                  <div className="search-box position-relative">
                    <input
                      className="form-control ps-6"
                      placeholder="Search Payment"
                      onChange={filterByName}
                    />
                    <i className="bx bx-search-alt search-icon"></i>
                  </div>
                  <select
                    className="form-select w-auto rounded-5"
                    value={SelectedCustomer}
                    onChange={e => setSelectedCustomer(e.target.value)}
                  >
                    <option value={0}>All</option>
                    {Customers.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.customerName}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="mt-3 mt-xl-0">
                  {/* {checkAccess(1, 1) && (
                    <>
                      <button
                        className="btn Add-Button rounded-5 me-2"
                        onClick={() => setModal(true)}
                      >
                        <MdUpload className="me-1" />
                        Bulk Import
                      </button>
                    </>
                  )} */}
                  {checkAccess(10, 2) && (
                    <button
                      className="btn Add-Button rounded-5 mt-3 mt-xl-0"
                      onClick={() => Navigate(`${ConfigUrl.appurl}add-payout`)}
                    >
                      <MdAdd /> Add Payment
                    </button>
                  )}
                </div>
              </div>

              <Row>
                <Col md="4">
                  <Card
                    className="mini-stats-wid my-3"
                    style={{ cursor: "pointer" }}
                  >
                    <CardBody>
                      <div className="d-flex">
                        <div className="flex-grow-1">
                          <h5 className=" fw-medium">Total Payout</h5>
                          <h4 className="mb-0 text-dark">
                            {totalPayout ? totalPayout.toFixed(2) : 0}
                          </h4>
                        </div>
                        <div className="avatar-sm rounded-circle align-self-center mini-stat-icon">
                          <span className="avatar-title rounded-circle">
                            <FaRupeeSign fontSize={24} />
                          </span>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <div className="table-responsive">
                <table className="mb-0 table Custom-Table">
                  <thead>
                    <tr>
                      <th>Sr No.</th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("VoucherNo")}
                      >
                        Voucher No. {getSortArrow("VoucherNo")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("customerName")}
                      >
                        Customer Name {getSortArrow("customerName")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("Date")}
                      >
                        Date {getSortArrow("Date")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("Type")}
                      >
                        Voucher Type {getSortArrow("Type")}
                      </th>
                      <th
                        style={{ cursor: "pointer" }}
                        onClick={() => requestSort("Amount")}
                      >
                        Amount {getSortArrow("Amount")}
                      </th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {final_data?.map((item, index) => (
                      <tr key={item?.id}>
                        <td>{(page - 1) * items_perpage + index + 1}</td>
                        <td>{item?.VoucherNo}</td>
                        <td>{item?.customer?.customerName}</td>
                        <td>
                          {moment(item?.Date, [
                            "YYYY-MM-DD",
                            "DD/MM/YYYY",
                          ]).format("DD MMMM YYYY")}
                        </td>
                        <td>{item?.Type}</td>
                        <td
                          style={{
                            color: item?.Type === "PAYMENT" ? "red" : "green",
                            fontWeight: 500,
                          }}
                        >
                          {item?.Type === "PAYMENT"
                            ? `₹ ${parseFloat(
                                String(item.Debit).replace(/[^0-9.-]+/g, "")
                              ).toLocaleString("en-IN")}`
                            : `₹ ${parseFloat(
                                String(item.Credit).replace(/[^0-9.-]+/g, "")
                              ).toLocaleString("en-IN")}`}
                        </td>

                        <td className="d-flex justify-content-center">
                          {checkAccess(10, 3) && (
                            <>
                              <button
                                className="btn Edit-Button me-2 rounded-5"
                                onClick={() =>
                                  Navigate(
                                    `${ConfigUrl.appurl}edit-payout/${item?.id}`
                                  )
                                }
                              >
                                <MdEdit /> Edit
                              </button>
                            </>
                          )}
                          {checkAccess(10, 4) && (
                            <button
                              className="btn delete-Button rounded-5"
                              onClick={() => handleDelete(item?.id)}
                            >
                              <MdDelete /> Delete
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}

                    {final_data.length == 0 && (
                      <tr>
                        <td colSpan={7} className="rounded-3">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="d-flex align-items-center justify-content-between my-4 px-2">
                <p className="mb-0 fs-7">
                  Showing {final_data?.length} out of {Data?.length} payments.
                </p>
                <div className="d-flex justify-content-md-start justify-content-center flex-wrap">
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 me-2 fs-5`}
                    onClick={() => changePage(page - 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronLeft />
                  </div>
                  {(() => {
                    const maxVisiblePages = 5
                    const startPage = Math.max(
                      1,
                      page - Math.floor(maxVisiblePages / 2)
                    )
                    const endPage = Math.min(
                      total_pages,
                      startPage + maxVisiblePages - 1
                    )
                    const visiblePages = []

                    for (let i = startPage; i <= endPage; i++) {
                      visiblePages.push(i)
                    }

                    return visiblePages.map(pagecount => (
                      <div
                        key={pagecount}
                        className={`bd-number-pagination cursor-pointer rounded-2 me-1 fs-5 ${
                          page === pagecount ? "activepage" : ""
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => changePage(pagecount)}
                      >
                        {pagecount < 10 ? "0" + pagecount : pagecount}
                      </div>
                    ))
                  })()}
                  <div
                    className={`bd-number-pagination cursor-pointer rounded-2 ms-2 fs-5`}
                    onClick={() => changePage(page + 1)}
                    style={{ cursor: "pointer" }}
                  >
                    <FaChevronRight />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <Modal
          open={AddModal}
          onCancel={() => setModal(false)}
          title="Payment Import"
          footer={false}
          width={800}
          style={{ top: 50 }}
        >
          <div className="Modal-Body mt-4">
            <div className="Card">
              <h5 className="fw-bold mb-0">Bulk Payment Upload</h5>
              <div className="Instruction">
                <div className="Instruction-main">
                  <span>All Steps</span>
                  <ol>
                    <li>
                      Download the sample file and fill it with proper data.
                    </li>
                    <li>
                      You can download the example file to understand how the
                      data must be filled.
                    </li>
                    <li>
                      Once you have downloaded and filled the sample file,
                      upload it in the form below and submit.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div className="Card mt-2">
              <h5 className="fw-bold mb-0">Bulk Payment Upload</h5>
              <div className="Instruction">
                <div className="form-group">
                  <label className="fw-bold fs-6">
                    Upload File <span className="text-danger">*</span>
                  </label>
                  <input
                    type="file"
                    accept=".xlsx , .xls"
                    className="form-control"
                    onChange={e => {
                      console.log(e)
                      setPaymentsFile(e.target.files[0])
                    }}
                  />
                </div>
                <div
                  className="btn delete-Button mt-3 fs-6"
                  onClick={() => handleUpload()}
                >
                  <MdUpload /> Upload
                </div>
                <div
                  className="btn delete-Button mt-3 fs-6 ms-3"
                  onClick={() => handleSampleDownload()}
                >
                  <MdDownload /> Download Sample File
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </PermittedComponent>
    </React.Fragment>
  )
}

export default Payout
